import { Expose } from "@nts/std/serialization";
import { ServiceRequest } from './service-request';

export class StoreRequest<TModel> extends ServiceRequest {

  @Expose()
  model: TModel;
}
